module.exports = __webpack_public_path__ + "img/portada.0ae0c545.webp";